// extracted by mini-css-extract-plugin
export default {"selector":"selector-ezyn","theme":"theme-zEQ6","sidebar":"sidebar-Vd68","main":"main-PmkO"};